import { type MutationHookOptions, useMutation } from "@apollo/client";
import { InviteOrganizationUserMutation } from "../graphql/mutations";
import type {
  InviteOrganizationUserMutationType,
  InviteOrganizationUserMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useInviteOrganizationUserMutation = (
  options?: MutationHookOptions<
    InviteOrganizationUserMutationType,
    InviteOrganizationUserMutationVariablesType
  >
) => {
  return useMutation<
    InviteOrganizationUserMutationType,
    InviteOrganizationUserMutationVariablesType
  >(InviteOrganizationUserMutation, options);
};
